import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../../../models/base/base-component';
import { Location } from '@angular/common';
import { ScreenService } from 'src/app/services/screen-service.service';
import { LoadingOptions } from '../../../../models/shared/loading-options';
import { InternalUser } from '../../../../models/users/dto/internal-user';
import { EmployerUser } from '../../../../models/users/dto/employer-user';
import { DropDownItem } from '../../../../models/shared/stylesheet/drop-down-item';
import { AddRoleMap } from '../../../../models/shared/add-role-map';
import { PortalService } from '../../../../services/portal/portal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { emailValidator } from '../../../../validators/email.validator';
import { UserRole } from '../../../../models/roles/user-role';

@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.scss']
})
export class ViewUserComponent extends BaseComponent implements OnChanges {
  constructor(protected location: Location) {
    super();
  }

  private screenService = inject(ScreenService);
  private portalService = inject(PortalService);

  public isMobile$ = this.screenService.isMobile$;
  public isInternal$ = this.portalService.isInternal$;
  public isEmployer$ = this.portalService.isEmployer$;
  public formSubmitAttempted: boolean = false;

  @Input() loadingOpts: LoadingOptions = new LoadingOptions();
  @Input() user: InternalUser | EmployerUser | null = null;
  @Input() canEditUser: boolean = false;
  @Input() statusDropdowns: DropDownItem[] = [];
  @Input() userRoleMap: AddRoleMap = new AddRoleMap();
  @Input() lastLoginTime: string = '';
  @Input() userHasNotLoggedIn: boolean = false;

  @Output() userUpdated = new EventEmitter<InternalUser | EmployerUser>();
  @Output() resendInvite = new EventEmitter<boolean>();
  @Output() openChangeEmailModal = new EventEmitter<void>();

  public formGroup = new FormGroup({
    firstName: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required]
    }),
    lastName: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required]
    }),
    email: new FormControl<string>(
      { value: '', disabled: true },
      {
        nonNullable: true,
        validators: [Validators.required, emailValidator]
      }
    ),
    status: new FormControl<boolean | null>(null, {
      nonNullable: true,
      validators: [Validators.required]
    }),
    roles: new FormControl<number[]>([], {
      nonNullable: true,
      validators: [Validators.required]
    })
  });

  private populateForm(user: InternalUser | EmployerUser | null): void {
    if (!user) return;
    this.formGroup.setValue({
      firstName: user.firstName ?? '',
      lastName: user.lastName ?? '',
      email: user.email ?? '',
      roles: user.roles?.map(r => r.roleId) ?? [],
      status: user.active ?? null
    });
    this.formGroup.updateValueAndValidity();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.user) {
      this.populateForm(this.user);
    }
  }

  public saveChanges(): void {
    this.formSubmitAttempted = true;
    const rolesValid = this.formGroup.controls.roles.value?.every(r => r !== null);
    if (this.formGroup.valid && rolesValid) {
      const form = this.formGroup.value;
      this.userUpdated.emit({
        ...this.user,
        firstName: form.firstName ?? '',
        lastName: form.lastName ?? '',
        email: form.email ?? '',
        roles: form.roles?.map(r => new UserRole(r)) ?? [],
        active: form.status ?? null
      } as InternalUser | EmployerUser);
    }
  }

  setupBindings(): void {}

  setupViews(): void {}

  public goBack(): void {
    this.location.back();
  }
}
